import Shimmer from "components/ui/shimmer"

const CollectionMenuSkeleton = () => (
  <div
    className="widescreen:py-60 tablet:px-32 widescreen:px-60 large:justify-center tablet:gap-16 widescreen:gap-24 xlarge:gap-40 flex justify-start gap-8 px-16 py-32"
    style={{
      "--base-basis": "25vw",
      "--desktop-basis": "13vw",
      "--large-basis": "140px",
      "--tablet-basis": "18vw",
      "--xlarge-basis": "180px",
    }}
  >
    {[...Array(8)].map((_, index) => (
      <div
        className="xlarge:basis-(--xlarge-basis) large:basis-(--large-basis) desktop:basis-(--desktop-basis) basis-(--base-basis) tablet:basis-(--tablet-basis) shrink-0 grow-0 text-center"
        key={`collection-menu-skeleton-${index}`}
      >
        <div className="px-8">
          <Shimmer className="mx-auto aspect-square h-auto w-full rounded-full" />
        </div>
        <Shimmer className="widescreen:mt-16 mt-8" style={{ height: "18px" }} />
      </div>
    ))}
  </div>
)

export default CollectionMenuSkeleton
